/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { ErrorType } from '../../modules/Network/orvalHTTPInterface';
import { HTTP } from '../../modules/Network/orvalHTTPInterface';

import type { ApiSeoLocationCityReviewsListParams } from './model/apiSeoLocationCityReviewsListParams';
import type { PaginatedProviderRatingList } from './model/paginatedProviderRatingList';

/**
 * Returns provider ratings for a given SEO location.
 */
export const apiSeoLocationCityReviewsList = (
  countryUrlPrefix: string,
  language: string,
  city: string,
  regionSlug: string,
  seoSlug: string,
  params?: ApiSeoLocationCityReviewsListParams,
  signal?: AbortSignal
) => {
  return HTTP<PaginatedProviderRatingList>({
    url: `/api/v7/seo-location/${countryUrlPrefix}/${language}/${city}--${regionSlug}--${seoSlug}/reviews/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getApiSeoLocationCityReviewsListQueryKey = (
  countryUrlPrefix?: string,
  language?: string,
  city?: string,
  regionSlug?: string,
  seoSlug?: string,
  params?: ApiSeoLocationCityReviewsListParams
) => {
  return [
    `/api/v7/seo-location/${countryUrlPrefix}/${language}/${city}--${regionSlug}--${seoSlug}/reviews/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getApiSeoLocationCityReviewsListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSeoLocationCityReviewsList>>,
  TError = ErrorType<unknown>
>(
  countryUrlPrefix: string,
  language: string,
  city: string,
  regionSlug: string,
  seoSlug: string,
  params?: ApiSeoLocationCityReviewsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiSeoLocationCityReviewsList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiSeoLocationCityReviewsListQueryKey(
      countryUrlPrefix,
      language,
      city,
      regionSlug,
      seoSlug,
      params
    );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSeoLocationCityReviewsList>>> = ({
    signal,
  }) =>
    apiSeoLocationCityReviewsList(
      countryUrlPrefix,
      language,
      city,
      regionSlug,
      seoSlug,
      params,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(countryUrlPrefix && language && city && regionSlug && seoSlug),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof apiSeoLocationCityReviewsList>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type ApiSeoLocationCityReviewsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSeoLocationCityReviewsList>>
>;
export type ApiSeoLocationCityReviewsListQueryError = ErrorType<unknown>;

export function useApiSeoLocationCityReviewsList<
  TData = Awaited<ReturnType<typeof apiSeoLocationCityReviewsList>>,
  TError = ErrorType<unknown>
>(
  countryUrlPrefix: string,
  language: string,
  city: string,
  regionSlug: string,
  seoSlug: string,
  params?: ApiSeoLocationCityReviewsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiSeoLocationCityReviewsList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiSeoLocationCityReviewsListQueryOptions(
    countryUrlPrefix,
    language,
    city,
    regionSlug,
    seoSlug,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
